import { OptionDto } from "@/dtos";
import { CompanyStatus } from "@/helpers/types/fleet-management/companies/company-status";

const status = [
    { value: parseInt(CompanyStatus.WORKING), label: 'OPERANDO' },
    { value: parseInt(CompanyStatus.DEMO), label: 'DEMO' },
] as OptionDto[];


export const getStatusOptions = (): OptionDto[] => {
    return status;
}

export const getStatusOption = (value: number): OptionDto => {
    return status.find((x) => x.value == value) ?? status[0];
}

export const getStatusCompany = (value: number): CompanyStatus => {
    switch (value) {
        case 1001:
            return CompanyStatus.WORKING;
        case 1002:
            return CompanyStatus.DEMO;
        case 1003:
            return CompanyStatus.DISABLE;
        default:
            return CompanyStatus.WORKING;
    }
}